import React, { useState } from "react";
import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";
import { useTranslation } from "react-i18next";
import { SERVICE_AUDIENCES } from "../../admin/_lmsActions";

// Choose the learner context before/within preview. Audience filters the course
// intro asset; area filters the module support asset.
const LmsPreviewPersonaModal = ({ open, audience, area, onStart, onClose }) => {
  const { t } = useTranslation();
  const [aud, setAud] = useState(audience || "ESHS");
  const ar = area || "ESSEX";

  return (
    <Modal
      showCloseIcon
      classNames={{ modal: "admin-modal lms-persona-modal", root: "modal-own-wrapper" }}
      open={open}
      onClose={onClose}
      center
    >
      <div>
        <p className="admin-banner">{t("admin.lms.preview.configTitle")}</p>
      </div>
      <div className="px-3 py-2">
        <h5 className="lms-subsection-title">
          {t("admin.lms.learners.serviceAudience")}
        </h5>
        <div className="lms-persona-options">
          {SERVICE_AUDIENCES.map((a) => (
            <label
              key={a}
              className={`lms-persona-option ${aud === a ? "selected" : ""}`}
            >
              <input
                type="radio"
                name="persona-aud"
                checked={aud === a}
                onChange={() => setAud(a)}
              />
              <span className="lms-persona-option-label">
                {t(`admin.lms.audience.${a}`, a)}
              </span>
            </label>
          ))}
        </div>

        {/* <h5 className="lms-subsection-title mt-3">
          {t("admin.lms.learners.serviceArea")}
        </h5>
        <div className="lms-persona-options">
          {SERVICE_AREAS.map((a) => (
            <label
              key={a}
              className={`lms-persona-option ${ar === a ? "selected" : ""}`}
            >
              <input
                type="radio"
                name="persona-area"
                checked={ar === a}
                onChange={() => setAr(a)}
                className="mr-2"
              />
              {t(`admin.lms.area.${a}`, a)}
            </label>
          ))}
        </div> */}

        <div className="d-flex justify-content-end mt-4 btn-with-icon">
          <button
            className="btn secondary-btn"
            onClick={() => onStart?.({ audience: aud, area: ar })}
          >
            <i className="fas fa-play mr-1"></i>
            {t("admin.lms.preview.start")}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default LmsPreviewPersonaModal;
